import { render, staticRenderFns } from "./CardResetPassword.vue?vue&type=template&id=de44ed1c&scoped=true"
import script from "./CardResetPassword.vue?vue&type=script&lang=js"
export * from "./CardResetPassword.vue?vue&type=script&lang=js"
import style0 from "./CardResetPassword.vue?vue&type=style&index=0&id=de44ed1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de44ed1c",
  null
  
)

export default component.exports